import React, { useState, useEffect } from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
// Navigation HTML classique pour les articles

/**
 * BlogPostsBlock - Affiche les publications blog publiées
 * 
 * Source de vérité: is_published = true
 * Endpoint: GET /api/publications?published_only=true
 */
const BlogPostsBlock = ({ block }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const config = block?.content || {};
  const title = config.title || 'Actualités & Tendances';
  const maxPosts = config.maxPosts || 200;

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/publications?published_only=true&limit=${maxPosts}`
      );
      if (response.ok) {
        const data = await response.json();
        // Filtrer uniquement les publications avec is_published=true (double sécurité)
        const publishedPosts = data.filter(post => post.is_published === true);
        setPosts(publishedPosts);
      }
    } catch (error) {
      console.error('Erreur chargement publications:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="py-12">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-muted-foreground">Aucune publication pour le moment.</p>
      </div>
    );
  }

  // Vue liste des posts
  return (
    <div className="py-8" data-testid="blog-posts-block">
      <h2 className="text-2xl font-heading font-bold mb-8">{title}</h2>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <a key={post.id} href={`/blog/${post.slug}`} className="block">
          <article 
            className="bg-white border rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
            data-testid={`blog-post-${post.id}`}
          >
            {post.image && (
              <img 
                src={post.image} 
                alt={post.title}
                className="w-full h-48 object-cover"
              />
            )}
            
            <div className="p-6">
              <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                <Calendar className="h-4 w-4" />
                <span>{formatDate(post.created_at)}</span>
              </div>
              
              <h3 className="text-lg font-semibold mb-2 line-clamp-2">
                {post.title}
              </h3>
              
              <p className="text-muted-foreground text-sm line-clamp-3 mb-4">
                {post.content.substring(0, 150)}...
              </p>
              
              <div className="flex items-center text-primary text-sm font-medium">
                Lire la suite
                <ArrowRight className="h-4 w-4 ml-1" />
              </div>
            </div>
          </article>
          </a>
        ))}
      </div>
    </div>
  );
};

export default BlogPostsBlock;
